/**
 * Where a magic link lands.
 *
 * This is not a route name we get to choose any more. The WhatsApp template
 * `preplift_signin_link` is approved by Meta with a dynamic URL button whose
 * prefix is `MAGIC_LINK_BASE_URL` + `?token=`, and Meta appends the token to
 * *that approved prefix*. Changing this path means submitting a new template
 * and waiting on another review, and until it is approved every parent gets a
 * link that does not work.
 *
 * It must equal the path component of the backend's `MAGIC_LINK_BASE_URL`,
 * which defaults to `https://app.preplift.in/auth/callback`.
 *
 * The page it renders is `ExchangePage`, which used to live only at
 * `/auth/exchange` — and that is exactly how this broke: the backend built
 * links at `/auth/callback`, the app served `/auth/exchange`, and every real
 * magic link 404'd. Nothing caught it because the development shortcut on the
 * sign-in screen navigates straight to the component and never goes through
 * the URL a message actually contains.
 */
export const MAGIC_LINK_PATH = '/auth/callback';

/**
 * The path this page used to live at.
 *
 * Kept because links already sent are in people's WhatsApp history, and
 * because the sign-in screen's development shortcut uses it. Same component,
 * so a token arriving at either one works.
 */
export const LEGACY_MAGIC_LINK_PATH = '/auth/exchange';
